import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from '../../../assets/img/team/avatar.png';
import Avatar from '../../common/Avatar';
import LinerLogo from '../../../assets/images/liner-logo.png';
import Flex from '../../common/Flex';
import { useSelector } from 'react-redux';
import axios from 'axios';
import axiosInstance from '../../../axiosSetup';
import { toast } from 'react-toastify';
import Divider from '../../common/Divider';
import { useTranslation } from 'react-i18next';
import { unsubscribeNotification } from '../../../layouts/NotificationModal';

const ProfileDropdown = () => {
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const CLIENT_APP_HOST = process.env.REACT_APP_CLIENT_APP_HOST || '';
  const { t } = useTranslation();
  const navigate = useNavigate();
  const profileDetails = useSelector((state) => state.userProfile.profile);

const handleLogout = async () => {
  try {
    const isTpdcs = window.location.href.includes('tpdcs');
    const primaryApp = isTpdcs ? '.tpdcs.com' : '.odexglobal.com';

    const windowLoc = window.location.href.indexOf(primaryApp);
    const windowurl = window.location.href.substring(0, windowLoc);

    let dropUrl;

    if (isTpdcs) {
      dropUrl = `${windowurl}${primaryApp}/drop`;
    } else {
      dropUrl = `${windowurl}${primaryApp}${APP_PATH_PREFIX}/drop`;
    }

    console.log("Unsubscribing notifications...");
    await unsubscribeNotification();

    console.log("Calling logout API...");

    // Use centralized axiosInstance
    await axiosInstance.get(`/api/user-management/v1/users/logout`);

    console.log("Redirecting to drop endpoint...");

    window.location.href = dropUrl;

    } catch (error) {
      toast.error('Unable to logout');
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
      <Dropdown navbar as="li">
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className="pe-0 ps-2 nav-link"
        >
          <Flex direction="row" justifyContent="end" alignItems="center">
            <div
              className={
                profileDetails?.partnerType === 'liner'
                  ? 'linerProfileIcon'
                  : 'customerProfile'
              }
            >
              {profileDetails?.username?.substring(0, 1)}
            </div>
          </Flex>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
          <div className="bg-white rounded-2 py-2 dark__bg-1000">
            <Dropdown.Item disabled>
              <span className="text-secondary" style={{ fontSize: '16px' }}>
                {profileDetails.username}
              </span>
            </Dropdown.Item>
            <Divider />
            <Dropdown.Item as={Link} to={`${APP_PATH_PREFIX}/user/profile`}>
              {t('resource_3:ProfileAccount')}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              as="div"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/change-password`)}
            >
              {t('resource_2:changePassword')}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item as="div" onClick={handleLogout}>
              {t('resource_1:logout')}
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default ProfileDropdown;
